/**
 * Vuex mutations for the customercare module.
 *
 * @module store/modules/customercare/mutations
 */
import Vue from "vue";
import { MutationTree } from "vuex/types";

import { CustomerCareState } from "./types";

const mutations: MutationTree<CustomerCareState> = {
  /**
   * Sets the list of available Metabase dashboards from collection.
   *
   * @param {CustomerCareState} state - Module state
   * @param {Array} payload - Array of dashboard configurations
   */
  CUSTOMER_CARE_SET_DASHBOARDS: (state, payload) => {
    Vue.set(state, "dashboards", payload);
  },

  /**
   * Sets the currently selected tab.
   *
   * @param {CustomerCareState} state - Module state
   * @param {string} payload - Tab identifier
   */
  CUSTOMER_CARE_SET_SELECTED_TAB: (state, payload) => {
    Vue.set(state, "selectedTab", payload);
  },

  /**
   * Sets the editor visibility state.
   *
   * @param {CustomerCareState} state - Module state
   * @param {boolean} payload - Visibility flag
   */
  CUSTOMER_CARE_SET_EDITOR_VISIBLE: (state, payload) => {
    Vue.set(state, "editorVisible", payload);
  },

  /**
   * Toggles the editor visibility state.
   *
   * @param {CustomerCareState} state - Module state
   */
  CUSTOMER_CARE_TOGGLE_EDITOR_VISIBLE: (state) => {
    Vue.set(state, "editorVisible", !state.editorVisible);
  },
};

export default mutations;
